import { Injectable, Inject, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WINDOW } from './windows.service';
@Injectable({
  providedIn: 'root'
})
export class NavService {
//  public  viewSubject = new BehaviorSubject<number>(null)

  constructor(@Inject(WINDOW) private window) {
    this.onResize();
    if (this.screenWidth < 768) {
      this.collapseSidebar = true;
    }
  }

  public screenWidth: any;
  public collapseSidebar = false;
  public collapseSecondHeader = false;


  // Windows width
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }


  // getView(i?){
  //   if(i){
  //     localStorage.setItem('header',i);
  //   this.viewSubject.next(i);
  // }
  //   else
  //   this.viewSubject.next(Number(localStorage.getItem('header')))

  // }
}
